var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 75.6493,
    height: 75.6493,
    rx: 37.8246,
    stroke: "#FF3F3C",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5375 21.3026C54.9172 20.8695 55.4652 20.6212 56.0413 20.6212H57.9973C59.7166 20.6212 60.6346 22.647 59.5011 23.9398L47.5946 37.5181C46.9685 38.2322 46.9308 39.288 47.5045 40.0448L62.7827 60.202C63.7811 61.5191 62.8416 63.4101 61.1888 63.4101H51.5662C50.9443 63.4101 50.3578 63.1208 49.9792 62.6273L40.5928 50.3891C39.825 49.3881 38.3334 49.3393 37.5018 50.288L26.5971 62.7284C26.2174 63.1616 25.6692 63.4101 25.0931 63.4101H23.1258C21.4067 63.4101 20.4886 61.3846 21.6218 60.0918L34.6273 45.2542C35.2557 44.5373 35.2907 43.4766 34.7111 42.7198L20.2489 23.8373C19.2411 22.5214 20.1793 20.6212 21.8367 20.6212H31.7975C32.4235 20.6212 33.0135 20.9143 33.3915 21.4133L41.6679 32.3363C42.4326 33.3456 43.9309 33.3991 44.7658 32.447L54.5375 21.3026ZM52.0963 58.4395C52.4006 58.8366 52.8724 59.0695 53.3727 59.0695V59.0695C54.7015 59.0695 55.457 57.5493 54.6545 56.4901L31.111 25.415C30.7867 24.987 30.2806 24.7355 29.7436 24.7355V24.7355C28.3217 24.7355 27.517 26.3659 28.3819 27.4945L52.0963 58.4395Z",
    fill: "#FF3F3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.839cdada854d519f33f862319185744c.svg";
export { ForwardRef as ReactComponent };